export default __webpack_public_path__ + "23fe48059c4a73d8ce9e415f2818e49f.png";